import { render, staticRenderFns } from "./Person.vue?vue&type=template&id=fb2015e0&scoped=true&"
import script from "./Person.vue?vue&type=script&lang=js&"
export * from "./Person.vue?vue&type=script&lang=js&"
import style0 from "./Person.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Person.vue?vue&type=style&index=1&id=fb2015e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2015e0",
  null
  
)

export default component.exports